/**Use in place of .includes. Takes in the word, search term, and index to start from.
 *  Will default to .includes if present in String.prototype
*/

export const Includes = (word, search, start) => {
  if (!String.prototype.includes) {
    if (typeof start !== 'number') {
      start = 0;
      if (start + search.length > word.length) {
        return false;
      } else {
        return word.indexOf(search, start) !== -1;
      }
    };
  } else {
    return word.includes(search);
  }
};


// WEBPACK FOOTER //
// ./src/utils/PolyFillFunctions.js